import './App.css';
import {
  createHashRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  useLocation,
} from "react-router-dom";

import MainLayout from './components/layout/mainlayout/MainLayout.jsx';
import routes from './routes.js';
import React, { useEffect, useRef } from 'react';
import Login from './Login.jsx';
import LoadingBar from 'react-top-loading-bar'

function App() {
  const loading = (
    <div className="pt-3 text-center">
      <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
  );
  const router = createHashRouter(
    createRoutesFromElements(
      <Route path="/">
        {/* <Route path="forgot-password" element={<ForgotPassword />} /> */}
        <Route path="login" element={<Login />} />
        <Route path="/" element={<MainLayout />}>
          {routes.map((route, idx) => (
            <Route key={idx} path={route.path} element={<route.component />} />
          ))}
        </Route>
      </Route>
    )
  );

  return (

    <div className="App">
      <React.Suspense fallback={loading}>

        <RouterProvider router={router} />
      </React.Suspense>
    </div>
  );
}

export default App;
